import { createStyles, rem } from "@mantine/core"
import { FieldError } from "react-hook-form"

export const useStyles = createStyles((theme, { error = undefined }: { error: FieldError }) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "0.375rem",
        "& .mantine-Text-root": {
            color: theme.colors.gray[7],
            fontSize: theme.fontSizes.sm,
            lineHeight: "1.0625rem",
        },
        "& .mantine-RichTextEditor-root": error && {
            border: `0.0625rem solid ${theme.colors.red[8]};`,
        },
    },
    selectedItem: {
        "&[data-hovered]": {
            backgroundColor: theme.colors.gray[2],
        },
    },
    unselectedItem: {
        "&hover": {
            backgroundColor: theme.colors.white,
        },
    },
    label: {
        fontSize: rem(14),
        fontWeight: 500,
        lineHeight: "normal",
        fontStyle: "normal",
    },
}))
